import { useState } from 'react';
import SortContainerListView from './list-view';
import PageTitle from '../../../components/PageTitle';
import { Nav, Tab } from 'react-bootstrap';
import SortConfiguration from './config-view';

const ComponentB = () => <div>This is Component B</div>;

const TabsExample = () => {
    const [activeTab, setActiveTab] = useState('Containers'); // default active tab

    const handleTabChange = (key: string) => {
        setActiveTab(key);
        // Reset or load data specific to the tab
    };

    return (
        <>
            <PageTitle
                title="Sort Containers"
                breadCrumbItems={[{ label: 'Sort containers', path: '/sort-containers', active: true }]}
            />
            <Tab.Container defaultActiveKey="Containers" onSelect={(key) => handleTabChange(key as string)}>
                <Nav variant="tabs" className="nav-bordered" as="ul" style={{ marginBottom: '1%' }}>
                    <Nav.Item as="li">
                        <Nav.Link eventKey="Containers">
                            <i className="mdi mdi-home-variant d-md-none d-block me-1"></i>
                            <span className="d-none d-md-block">Containers</span>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" onClick={() => {}}>
                        <Nav.Link eventKey="Configurations">
                            <i className="mdi mdi-account-circle d-md-none d-block me-1"></i>
                            <span className="d-none d-md-block">Configurations</span>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content className="surcharge-content">
                    <Tab.Pane eventKey="Containers">
                        {activeTab === 'Containers' && (
                            <SortContainerListView />
                        )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="Configurations">
                        {activeTab === 'Configurations' && <SortConfiguration />}
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </>
    );
};

export default TabsExample;